// A failure a later turn got past is history, not a current alarm; and the provider's own
// failure sentence said as assistant text above its card (the Claude CLI's "API Error: …") is not a reply.
import type { StreamEntry } from "./state.svelte.js";
import { isUsageLimitText } from "./usage-limit-repeats.js";

function isFailureEcho(entry: StreamEntry, next: StreamEntry | undefined): boolean {
  return (
    entry.kind === "text" && next?.kind === "error" && entry.content.trim() === next.content.trim()
  );
}

export function withoutFailureEcho(entries: readonly StreamEntry[]): readonly StreamEntry[] {
  if (!entries.some((entry, i) => isFailureEcho(entry, entries[i + 1]))) return entries;
  return entries.filter((entry, i) => !isFailureEcho(entry, entries[i + 1]));
}

/** Ids of the failure cards followed by a later prompt whose turn answered and did not fail. */
export function pastFailureIds(entries: readonly StreamEntry[]): ReadonlySet<string> {
  const past = new Set<string>();
  const waiting: string[] = [];
  let prompted = false;
  let answered = false;
  const settle = () => {
    if (answered) for (const id of waiting.splice(0)) past.add(id);
    answered = false;
  };
  for (const entry of entries) {
    if (entry.kind === "user_message") {
      settle();
      prompted = true;
    } else if (entry.kind === "error") {
      prompted = false;
      answered = false;
      waiting.push(entry.id);
    } else if (prompted && entry.kind === "text" && !isUsageLimitText(entry.content)) {
      answered = true;
    }
  }
  settle();
  return past;
}
